import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { ComponentsModule } from '../../components/components.module';
import { DirectivesModule } from '../../directives/directives.module';
import { PipesModule } from '../../pipes/pipes.module';
import { CuttingButtFormService } from '../../services/cutting-butt-form.service';
import { AngleSettingsModule } from '../angle-settings/angle-setting.module';
import { CuttingMaterialBaseDialogModule } from '../cutting-material-base-dialog/public-api';
import { EdgesInColorDialogModule } from '../edges-in-color-dialog/edges-in-color-dialog.module';
import { FastenersWizardDialogModule } from '../fasteners-wizard-dialog/fasteners-wizard-dialog.module';
import { HandlesDialogModule } from '../handles-dialog/handles-dialog.module';
import { MaterialBaseButtsDialogModule } from '../material-base-butts-dialog/material-base-butts-dialog.module';
import { TextureViewerModule } from '../texture-viewer/texture-viewer.module';
import { AngleProcessingDialogComponent } from './angle-processing-dialog/angle-processing-dialog.component';
import { AnglesProcessingComponent } from './angles-processing/angles-processing.component';
import { FacadeAvailableFilmMaterialsService } from './facade-available-film-materials.service';
import { FacadeSettingsDataService } from './facade-settings-data.service';
import { FacadeSettingsComponent } from './facade-settings.component';
import { FacadesAvailableComponentsService } from './facades-available-components.service';
import { FastenersComponent } from './fasteners/fasteners.component';
import { HandleComponent } from './handle/handle.component';
import { ItemCardComponent } from './item-card/item-card.component';
import { MaterialsComponent } from './materials/materials.component';
import { MillingsDialogComponent } from './millings-dialog/millings-dialog.component';
import { MillingsComponent } from './millings/millings.component';
import { SizesComponent } from './sizes/sizes.component';
import { SlotsComponent } from './slots/slots.component';

@NgModule({
  imports: [
    MatButtonModule,
    MatIconModule,
    MatExpansionModule,
    MatDialogModule,
    MatTableModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDividerModule,
    MatCheckboxModule,
    MatTooltipModule,

    FuseSharedModule,
    ComponentsModule,
    FastenersWizardDialogModule,
    AngleSettingsModule,
    EdgesInColorDialogModule,
    PipesModule,
    DirectivesModule,
    CuttingMaterialBaseDialogModule,
    MaterialBaseButtsDialogModule,
    HandlesDialogModule,
    TextureViewerModule,
  ],
  declarations: [
    FacadeSettingsComponent,
    MillingsDialogComponent,
    AngleProcessingDialogComponent,
    ItemCardComponent,
    MaterialsComponent,
    FastenersComponent,
    AnglesProcessingComponent,
    MillingsComponent,
    SlotsComponent,
    SizesComponent,
    HandleComponent,
  ],
  providers: [
    FacadeSettingsDataService,
    CuttingButtFormService,
    FacadesAvailableComponentsService,
    FacadeAvailableFilmMaterialsService,
  ],
  exports: [FacadeSettingsComponent],
})
export class FacadeSettingsModule {}
